import { render, staticRenderFns } from "./ColorBar.vue?vue&type=template&id=2e024d3a&scoped=true"
import script from "./ColorBar.vue?vue&type=script&lang=js"
export * from "./ColorBar.vue?vue&type=script&lang=js"
import style0 from "./ColorBar.vue?vue&type=style&index=0&id=2e024d3a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e024d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e024d3a')) {
      api.createRecord('2e024d3a', component.options)
    } else {
      api.reload('2e024d3a', component.options)
    }
    module.hot.accept("./ColorBar.vue?vue&type=template&id=2e024d3a&scoped=true", function () {
      api.rerender('2e024d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/ColorBar.vue"
export default component.exports